import { render, staticRenderFns } from "./OfficeContentComponent.vue?vue&type=template&id=b81f6050&scoped=true&"
import script from "./OfficeContentComponent.vue?vue&type=script&lang=js&"
export * from "./OfficeContentComponent.vue?vue&type=script&lang=js&"
import style0 from "./OfficeContentComponent.vue?vue&type=style&index=0&id=b81f6050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81f6050",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b81f6050')) {
      api.createRecord('b81f6050', component.options)
    } else {
      api.reload('b81f6050', component.options)
    }
    module.hot.accept("./OfficeContentComponent.vue?vue&type=template&id=b81f6050&scoped=true&", function () {
      api.rerender('b81f6050', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/office/OfficeContentComponent.vue"
export default component.exports